import React from 'react';
import '../../App.css';
import './Guide.css';
import Footer from '../Footer';
import { useTranslation } from "react-i18next";

export default function About() {

  const { t } = useTranslation();

  return <div className="guide-container">
    <div className="about-form">

      <h2>{t('text.cardText2')}</h2>
      <br></br>
      <br></br>
      <h3>{t('text.guideTitle')}</h3>
      <p>{t('text.guide1')}</p>
      <p>{t('text.guide2')}</p>
      <p>{t('text.guide3')}</p>
      <p>{t('text.guide4')}</p>
      <p>{t('text.guide5')}</p>
      <br></br>
      <h3>{t('text.guideTitle2')}</h3>
      <p>{t('text.guide6')}</p>
      <br></br>
      <h3>{t('text.guideTitle3')}</h3>
      <p>{t('text.guide7')}</p>
      <p>{t('text.guide8')}</p>
      <p>{t('text.guide9')}</p>
      <p>{t('text.guide10')}</p>
      <br></br>
      <h3>{t('text.guideTitle4')}</h3>
      <p>{t('text.guide11')}</p>
      <p>{t('text.guide12')}</p>
      <p>{t('text.guide13')}</p>
      <br></br>
      <h3>{t('text.guideTitle5')}</h3>
      <p>{t('text.guide14')}</p>


    </div>
    <Footer />
  </div>
}
